// extracted by mini-css-extract-plugin
module.exports = {"hr":"PromoCode_hr__Z5X76","promo-line":"PromoCode_promo-line__X58tc","promo-success":"PromoCode_promo-success__kU79c"};